import { PRIORITIES } from "./projectUtils";

export const assigneesOf = (t) => (t?.assignees?.length ? t.assignees : (t?.assigned_to ? [t.assigned_to] : []));
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const isOverdue = (t) => !!t?.due_date && t.status !== "Completed" && t.due_date < todayISO();
export const hoursDiff = (t) => Math.round(((Number(t?.actual_hours) || 0) - (Number(t?.estimated_hours) || 0)) * 100) / 100;

const PRIORITY_RANK = Object.fromEntries(PRIORITIES.map((p, i) => [p, i]));

export function filterAndSortTasks(tasks, { q = "", status = "all", priority = "all", assignee = "all", overdue = false, sort = "due" }) {
  const needle = q.trim().toLowerCase();
  const list = tasks.filter(t =>
    (!needle || `${t.task_id} ${t.name}`.toLowerCase().includes(needle)) &&
    (status === "all" || t.status === status) &&
    (priority === "all" || t.priority === priority) &&
    (assignee === "all" || (assignee === "none" ? assigneesOf(t).length === 0 : assigneesOf(t).includes(assignee))) &&
    (!overdue || isOverdue(t))
  );
  const by = {
    due: (a, b) => (a.due_date || "9999").localeCompare(b.due_date || "9999"),
    priority: (a, b) => (PRIORITY_RANK[b.priority] ?? -1) - (PRIORITY_RANK[a.priority] ?? -1),
    created: (a, b) => (b.created_at || "").localeCompare(a.created_at || ""),
    updated: (a, b) => (b.updated_at || b.created_at || "").localeCompare(a.updated_at || a.created_at || ""),
  }[sort];
  return [...list].sort(by);
}
